<template>
  <div>
    <el-container>
      <el-main>
        <el-row>添加规则</el-row>
        <el-form
          ref="ruleForm"
          :model="ruleForm"
          :rules="rules"
          label-width="150px"
          class="demo-ruleForm"
        >
          <el-form-item
            label="规则名称(必填)"
            prop="name"
          >
            <el-input
              v-model="ruleForm.name"
              placeholder="请输入内容"
              class="w45"
              maxlength="15"
              show-word-limit
            />
          </el-form-item>
          <el-form-item
            label="适用时间范围(必填)"
            prop="dateRange"
          >
            <el-date-picker
              v-model="ruleForm.dateRange"
              :style="{ width: '380px', marginRight: '20px' }"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            />
          </el-form-item>
        </el-form>

        <el-header>
          <el-row class="bb">
            <el-col :span="4">
              <div class="grid-content">
                订单归属
              </div>
            </el-col>
            <el-col :span="10">
              <div class="grid-content">
                销售导购
              </div>
            </el-col>
            <el-col :span="10">
              <div class="grid-content">
                绑定导购
              </div>
            </el-col>
          </el-row>
        </el-header>
        <el-main>
          <el-row>
            <el-col :span="4">
              <div class="grid-content">
                员工
              </div>
            </el-col>
            <el-col :span="10">
              <div class="grid-content bb">
                100%
              </div>
            </el-col>
            <el-col :span="10">
              <div class="grid-content bb" />
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <div class="grid-content" />
            </el-col>
            <el-col
              :span="10"
            >
              <div class="grid-content bb">
                <el-input
                  v-model="proportion.sales.value"
                  placeholder="业绩比例"
                  class="w45"
                  max="100"
                >
                  <template slot="append">
                    %
                  </template>
                </el-input>
              </div>
            </el-col>
            <el-col
              :span="10"
            >
              <div class="grid-content bb">
                <el-input
                  v-model="proportion.bind.value"
                  placeholder="业绩比例"
                  class="w45"
                  max="100"
                >
                  <template slot="append">
                    %
                  </template>
                </el-input>
              </div>
            </el-col>
          </el-row><el-row>
            <el-col :span="4">
              <div class="grid-content bb" />
            </el-col>
            <el-col :span="10">
              <div class="grid-content bb" />
            </el-col>
            <el-col
              :span="10"
            >
              <div class="grid-content bb">
                <el-input
                  v-model="proportion.bind_operate.value"
                  placeholder="业绩比例"
                  class="w45 mr10"
                  max="100"
                >
                  <template slot="append">
                    %
                  </template>
                </el-input>
                <el-link
                  type="primary"
                  @click="exclusionVisible = true"
                >
                  业绩排他 <i class="el-icon-question" />
                </el-link>
              </div>
            </el-col>
          </el-row><el-row>
            <el-col :span="4">
              <div class="grid-content">
                编外
              </div>
            </el-col>
            <el-col :span="10">
              <div class="grid-content bb">
                100%
              </div>
            </el-col>
            <el-col :span="10">
              <div class="grid-content bb" />
            </el-col>
          </el-row>
          <el-row class="bb">
            <el-col :span="4">
              <div class="grid-content" />
            </el-col>
            <el-col
              :span="10"
            >
              <div class="grid-content">
                <el-input
                  v-model="proportion.operate_bind.value"
                  placeholder="业绩比例"
                  class="w45"
                  max="100"
                >
                  <template slot="append">
                    %
                  </template>
                </el-input>
              </div>
            </el-col>
            <el-col :span="10">
              <div class="grid-content" />
            </el-col>
          </el-row>
        </el-main>
        <el-row
          type="flex"
          justify="end"
          class="pr20"
        >
          <el-button @click="cancelAction">
            取消
          </el-button>
          <el-button
            type="primary"
            @click="submitForm('ruleForm')"
          >
            确定
          </el-button>
        </el-row>
      </el-main>
    </el-container>
    <!-- 业绩排他 -->
    <Exclusion
      :exclusion-visible="exclusionVisible"
      :exclude-operate-store="excludeOperateStore"
      @exclusionVisibleChange="exclusionVisibleChange"
    />
  </div>
</template>

<script>
import moment from 'moment'
import { saveOtherSetting, getOtherSettingDetail } from '@/api/performance/distribution'
import Exclusion from '@/components/performanceDistribution/exclusion'
export default {
  name: 'Edit',
  components: {
    Exclusion
  },
  data () {
    return {
      proportion: {
        bind_sales: {
          title: '导购独立业绩',
          key: 3,
          key_str: 'bind_sales',
          value: '100',
          is_disable: true
        },
        sales: {
          title: '导购独立销售业绩',
          key: 1,
          key_str: '',
          value: '',
          is_disable: false
        },
        bind: {
          title: '独立绑定业绩',
          key: 2,
          key_str: '',
          value: '',
          is_disable: false
        },
        bind_operate: {
          title: '编外组合绑定业绩',
          key: 4,
          key_str: '',
          value: '',
          is_disable: false
        },
        operate_sales: {
          title: '运营专属销售业绩',
          key: 5,
          key_str: 'operate_sales',
          value: '100',
          is_disable: true
        },
        operate_bind: {
          title: '运营绑定销售业绩',
          key: 6,
          key_str: '',
          value: '',
          is_disable: false
        }
      },
      ruleForm: {
        name: '',
        dateRange: ''
      },
      rules: {
        name: [{ required: true, message: '请输入活动名称', trigger: 'blur' }],
        dateRange: [{ required: true, message: '请选择时间范围', trigger: 'blur' }]
      },
      exclusionVisible: false,
      excludeOperateStore: []
    }
  },
  computed: {
    valueLeft () {
      return this.proportion.sales.value
    },
    valueRight () {
      return this.proportion.bind.value
    }
  },
  watch: {
    // valueLeft(value) {
    //   this.proportion.bind.value = String(100 - Number(value) > 0 ? 100 - Number(value) : 0)
    // },
    // valueRight(value) {
    //   this.proportion.sales.value = String(100 - Number(value) > 0 ? 100 - Number(value) : 0)
    // }
  },
  mounted () {
    let params = this.$route.params
    if (+params.id) {
      this.ruleForm.id = params.id
      this.getInfo(params.id)
    }
  },
  methods: {
    async getInfo () {
      let id = this.ruleForm.id
      const data = await getOtherSettingDetail(id, { id }).catch(() => {})
      this.proportion = data.proportion
      this.ruleForm.name = data.name
      this.ruleForm.dateRange = [data.start_time, data.end_time]
      this.excludeOperateStore = data.exclude_operate_store.split(',')
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.checkTable()
        } else {
          return false
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },

    checkTable () {
      if (
        !this.proportion.sales.value ||
        !this.proportion.bind.value ||
        !this.proportion.bind_operate.value ||
        !this.proportion.operate_bind.value
      ) {
        this.$message.error('请填写表格内的值')
      } else {
        console.log('success')
        this.handleSaveOtherSetting()
      }
    },
    async handleSaveOtherSetting () {
      this.loading = true
      let params = {
        name: this.ruleForm.name,
        start_time: moment(this.ruleForm.dateRange[0]).format('YYYY-MM-DD'),
        end_time: moment(this.ruleForm.dateRange[1]).format('YYYY-MM-DD'),
        proportion: this.proportion,
        exclude_operate_store: this.excludeOperateStore.toString()
      }
      if (this.ruleForm.id !== 0) {
        params.id = this.ruleForm.id
      }
      const data = await saveOtherSetting(params).catch(() => {
        this.loading = false
      })
      if (data.status === true) {
        this.$message({
          type: 'success',
          message: '成功!'
        })
        this.$router.push({ path: `/customerConversion/performanceDistribution` })
      }
    },
    cancelAction () {
      this.$router.push({ path: `/customerConversion/performanceDistribution` })
    },
    exclusionVisibleChange (value) {
      if (value[0] === false) {
        this.exclusionVisible = false
      }
      if (value[1]) {
        this.excludeOperateStore = value[1]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.pr20 {
  padding-right: 20px;
}
.bb {
  border-bottom: 1px solid #e9e9e9;
}
.w45 {
  width: 45%;
}
.mr10 {
  margin-right: 10px;
}
.red {
  color: red;
}
.search-btn {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 20px;
  li {
    margin-right: 20px;
  }
}

.el-header {
  text-align: bottom;
  line-height: 60px;
}

.el-main {
  text-align: left;
}
.el-row {
  margin-bottom: 10px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-container {
  background-color: #fff;
}
.grid-content {
  min-height: 46px;
  padding: 0 5px;
}
</style>
